import {
  maxWidth,
  primaryHeadingColor, retina, secondaryFont,
  wMBold, xiqGptGlobalHeaderImageV2, xiqGptGlobalWriterAnimation,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div``;
const StyledWrapper = styled.div`
border-radius: 12px;
background: #DEF6E6;
display: flex;
align-items: center;
justify-content: space-between;
width: 100%;
min-height: 121px;
height: 121px;
@media all and (max-width: ${maxWidth}), ${retina} {
  min-height: 133px;
  height: 133px;
}
.header-v3-heading {
  color: ${primaryHeadingColor};
  font-family: ${secondaryFont};
  font-size: 42px;
  font-weight: ${wMBold};
  line-height: 40px;
  letter-spacing: -0.792px;
  margin-bottom: 0px;
  padding: 40px 0 41px;
  padding-left: 24px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 40px;
  }
}
.animation-div-v3 {
  position: relative;
  width: calc(50% - 130px);
  height: calc(100% - 0px);
  margin-right: 42px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    margin-right: 0px;
    width: calc(50% - 117px);
  }
  .image-container-v3 {
    position: absolute;
    top: 0px;
    width: calc(100% - 30px);
    height: calc(100% - 10px);
    margin-top: 10px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: calc(100% - 60px);
    }
    .image-inner-container-v3 {
      width: 100%;
      height: 100%;
      background-image: url(${xiqGptGlobalHeaderImageV2});
      background-position: center center;        
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .image-container-v3-gif {
    position: absolute;
    top: -4px;
    left: 60px;
    height: 75px;
    width: 75px;
    transform: rotate(23deg);
    @media all and (max-width: ${maxWidth}), ${retina} {
      top: 0px;
      left: 65px;
    }
  }
}
`;

const GilroyHeaderV3 = function GilroyHeaderV3() {
  return (
    <Wrapper className="header-gill-roy">
      <StyledWrapper className="gill-header-inner">
        <h3 className="header-v3-heading">Ask Gilroy</h3>
        <div className="animation-div-v3">
          <div className="image-container-v3">
            <div className="image-inner-container-v3" />
          </div>
          <img className="image-container-v3-gif" src={xiqGptGlobalWriterAnimation} alt="container-gif" />
        </div>
      </StyledWrapper>
    </Wrapper>
  );
};
export default GilroyHeaderV3;
